import React, { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { login, register, registerWithGoogle, registerWithFacebook } from '../api/auth';
import { FcGoogle } from 'react-icons/fc';
import { FaFacebook } from 'react-icons/fa';
import { useAuthStore } from '../store/store';
import { NavbarHeightContext } from '../helpers/NavbarHeightContext'; // To get the height of the navbar

const SignUp = () => {
    const [formData, setFormData] = useState({
        email: '',
        fullName: '',
        password: '',
        confirmPassword: '',
    });
    const [errorMessage, setErrorMessage] = useState('');
    const { setUser, setIsAuth } = useAuthStore(store => store);
    const navigate = useNavigate();

    const handleChange = e => {
        setFormData(prevFormData => {
            return {
                ...prevFormData,
                [e.target.name]: e.target.value,
            };
        });
    };

    const handleSubmit = async e => {
        e.preventDefault();

        if (formData.password !== formData.confirmPassword) {
            setErrorMessage('Passwords do not match!');
            return;
        }

        // TODO: Email Link Verification + Authentication with Google
        try {
            await register({
                email: formData.email,
                password: formData.password,
                fullName: formData.fullName,
            });

            const user = await login({
                email: formData.email,
                password: formData.password,
            });

            updateAuthStore(user, true);

            setErrorMessage('');

            navigate('/onboard', { state: { from: '/register' } });
        } catch (error) {
            setErrorMessage(error);
        }
    };

    const handleGoogleRegister = async() => {
        try {
            const res = await registerWithGoogle();
            updateAuthStore(res, true);
            if (res.isNewUser) {
                navigate('/onboard', { state: { from: '/register' } });
            } else {
                navigate('/');
            }
        } catch (e) {
            console.log(e);
        }
    };

    const handleFacebookRegister = async() => {
        try {
            const res = await registerWithFacebook();
            updateAuthStore(res, true);
            if (res.isNewUser) {
                navigate('/onboard', { state: { from: '/register' } });
            } else {
                navigate('/');
            }
        } catch (e) {
            console.log(e);
        }
    };

    const updateAuthStore = (user, isAuth) => {
        setUser(user);
        setIsAuth(isAuth);
    };

    // To get the height of the navbar and calculate the height of the sign up page
    const { navbarHeight } = useContext(NavbarHeightContext);
    const calculateSignUpPageHeight = () => {
        return `calc(100vh - ${navbarHeight}px)`;
    };

    return (
        <div className='flex flex-col justify-center items-center overflow-y-scroll' style={{ height: calculateSignUpPageHeight() }}>
            <div className="bg-white rounded-4 rounded-b-3xl w-full shadow p-6 max-w-md">
                <div className="flex flex-col items-center">
                    <h1 className="font-bold text-3xl mb-3">Sign Up</h1>
                    <h2 className="text-base font-normal mb-3">Get started with an account with us!</h2>
                </div>

                <form onSubmit={handleSubmit}>
                    <div>
                        <input
                            type='email'
                            placeholder='Type Your Email'
                            name='email'
                            onChange={handleChange}
                            required
                            className="mb-3 w-full py-2 px-3 border-solid border-black border-1 rounded-3 text-3 font-400"
                        />
                    </div>

                    <div>
                        <input
                            type='text'
                            placeholder='Type Your Full Name'
                            name='fullName'
                            onChange={handleChange}
                            required
                            className="mb-3 w-full py-2 px-3 border-solid border-black border-1 rounded-3 text-3 font-400"
                        />
                    </div>

                    <div>
                        <input
                            type='password'
                            placeholder='Password'
                            name='password'
                            onChange={handleChange}
                            required
                            className="mb-3 w-full py-2 px-3 border-solid border-black border-1 rounded-3 text-3 font-400"
                        />
                    </div>

                    <div>
                        <input
                            type='password'
                            placeholder='Confirm Your Password'
                            name='confirmPassword'
                            onChange={handleChange}
                            required
                            className="mb-3 w-full py-2 px-3 border-solid border-black border-1 rounded-3 text-3 font-400"
                        />
                    </div>

                    {errorMessage && <p className='text-red text-4 font-normal'>{errorMessage}</p>}
                    <button className='font-semibold w-100 py-2 px-1 rounded-3 text-4 bg-yellow mt-3 mx-auto border-black border-solid border-1'>Confirm</button>
                </form>

                <div className='flex items-center my-6 mx-0 justify-center gap-1'>
                    <hr className="w-44 border-1 border-solid border-black my-0 mx-1 grow-1"/>
                    <div className="flex items-center">
                        <p className='font-400 my-0 mx-2 text-5'>
                            Or
                        </p>
                    </div>
                    <hr className="w-44 border-1 border-solid border-black my-0 mx-1 grow-1"/>
                </div>

                <div className="flex flex-col items-center justify-center">
                    <div className="flex mb-4 gap-10">
                        <div className='py-0 border-none bg-transparent cursor-pointer' onClick={handleGoogleRegister}>
                            <FcGoogle className='w-6 h-6'/>
                        </div>
                        <div className='py-0 border-none bg-transparent cursor-pointer' onClick={handleFacebookRegister}>
                            <FaFacebook className='text-blue w-6 h-6'/>
                        </div>
                    </div>

                    <div className='flex items-center justify-center'>
                        <p className='m-0'>Already have an account?
                            <a href='#' onClick={() => navigate('/login')} className='ml-2 text-underline'>
                                Log In
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default SignUp;
